import React, { Component } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslate } from 'lib/translate';
import { Icon } from '@haldor/ui';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

class Expire extends Component {
	static defaultProps = {
		delay: 9000,
		expireMode: 'time', // 'time' or 'userClose'
	}

	constructor(props) {
		super(props);

		this.state = {
			visible: true,
		};

		this._timer = null;
	}

	componentDidMount = () => {
		if (this.props.expireMode === 'time') {
			this.setTimer();
		}
	}

	setTimer = () => {
		if (this._timer != null) {
			clearTimeout(this._timer);
		}

		this.setState({ visible: true }, () => {
			this._timer = setTimeout(() => {
				this.handleExpire();
			}, this.props.delay);
		});
	}

	componentWillUnmount = () => {
		clearTimeout(this._timer);
	}

	handleExpire = () => {
		this.setState({ visible: false });
		this._timer = null;
		if (this.props.onExpire) {
			this.props.onExpire();
		}
	}

	handleClose = () => {
		clearTimeout(this._timer);
		this.handleExpire();
	}

	render = () => (
		this.state.visible ?
			<div
				className={`error type-${this.props.type} is-visible`}
				style={{
					position: 'fixed',
					left: 0,
					right: 0,
					width: '100vw',
					zIndex: 9999,
					display: 'flex',
					padding: '0 16px'
				}}
			>
				<div style={{ flex: 1 }}>
					{this.props.children}
				</div>
				{this.props.expireMode === 'userClose' &&
					<button
						className="error-close-btn"
						onClick={this.handleClose}
						style={{
							background: 'none',
							border: 'none',
							fontSize: '16px',
							cursor: 'pointer',
							alignSelf: 'center',
							margin: '0px 20px'
						}}
					>
						<Icon name="Close" />
					</button>
				}
			</div>
			: null
	)
}

const Error = () => {
	const translate = useTranslate();
	const errors = useSelector(state => state.errors);

	const renderError = (error, i) => {
		if (error.viewed == true) {
			return null;
		}

		return (
			<Expire
				key={'error-' + i}
				onExpire={() => error.viewed = true}
				expireMode={error.expireMode ? error.expireMode : 'time'}
				type={error.type ? error.type : 'warning'}
			>
				<div className="content">
					{error.msg != null ?
						error.msg
						: error.translateMsg != null ?
							translate(error.translateMsg)
							: null}
				</div>
			</Expire>
		);
	}

	return (
		<div className="error-messages-container">
			{errors.map(renderError)}
		</div>
	);
}

export default Error;
